import React from 'react';
import PropTypes from 'prop-types';
import cn from './style.module.scss';

export function Title(props) {
  const className = `${cn.title} ${props.className}`;
  return <h3 className={className}>{props.title}</h3>;
}

Title.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * Main title
   */
  title: PropTypes.string 
};

Title.defaultProps = {
    className: ''
};
